import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_position_frame = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); 
  const navigate = useNavigate();

  const canView  = hasPermission("Branch Wise Vehicles Report", "view");

  // Fetch branches once
  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_details_list_frame_branch")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  // Fetch data based on selected branch
  useEffect(() => {
    if (selectedBranch) {
      axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_details_list_frame_branch?branch_code=${selectedBranch}`)
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        });
    }
  }, [selectedBranch]);

  // Pagination handling
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Search functionality
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => 
      item.fld_vehiclename && item.fld_vehiclename.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // Handle navigation selection
  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/vehicle_details_list');
    }
  };

  // Get selected branch name
  const selectedBranchName = branches.find(branch => branch.branchMaster_code === selectedBranch)?.branchMaster_name || "All Branches";

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  
  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Details List</h2>
          <div>
            <Time />
          </div>
        </section>

          <div className="vehicle-class">
  <div>
    <p>Select Branch :</p>
           <select 
            value={selectedBranch} 
            onChange={(e) => setSelectedBranch(e.target.value)} 
            required 
            className="branch-select"
          >
            <option value="">Select Branch</option>
            {branches.map((item) => (
              <option key={item.branchMaster_code} value={item.branchMaster_code}>
                {item.branchMaster_name}
              </option>
            ))}
          </select>
 </div>

  <div>
    <p>Select Vehicle Details :</p>
    <select className="branch-select" onChange={handleSelection}>     
            <option value="/hire">Branch Wise Report</option>  
            <option value="/own">Vehicle Details</option>  
    </select>
  </div>
</div>
    

      
        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input 
            type="text" 
            placeholder="Search by vehicleName" 
            value={searchTerm} 
            onChange={handleSearch} 
            className="search-input" 
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Type</th>
                <th>{selectedBranchName}</th>  
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.fld_vehiclename}</td>
                    <td>{item.Total}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>
              {index + 1}
            </button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_position_frame;
